
import { toast } from 'react-toastify';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
// import { withRouter } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';
import Isvg from 'react-inlinesvg';
import Dropzone from 'react-dropzone';
import Modal from 'react-modal';
import AvatarEditor from 'react-avatar-editor';
import moment from 'moment';

import { Theme } from '../../config/theme';
import {
  mapStateToProps,
  mapDispatchToProps,
  availability,
  sex,
  livingSituations,
  regularity,
  fixedStatuses,
} from '../../utils';

import { updateDogRemote } from '../../actions/pooch';
import { updateAppState } from '../../actions/applicationState';

// import InteractiveMap from '../../components/InteractiveMap';
import ErrorContainer from '../../components/ErrorContainer';
import ContentContainer from '../../components/ContentContainer';
import HorizontalRule from '../../components/HorizontalRule';
import TextField from '../../components/TextField';
import DateField from '../../components/DateField';
import CheckboxField from '../../components/CheckboxField';
import SimpleSelect from '../../components/SimpleSelect';
import CheckButton from '../../components/CheckButton';
import ActivityCard from '../../components/ActivityCard';

const POOCH_ASSET = require('./PoochIcon.svg');
const UPLOAD_ASSET = require('./Upload.svg');
const ROTATE_ICON = require('./rotate.png');

class EditPooch extends Component {
  constructor(props) {
    super(props);
    const dog = this.getDog();
    this.selectHandler = this.handleSelect.bind(this);
    this.setValue = this.updateField.bind(this);
    this.setMarkers = this.handleMarkers.bind(this);
    this.acceptFiles = this.handleFileDrop.bind(this);
    this.clearImage = this.handleClearImage.bind(this);
    this.saveDraft = this.handleSave.bind(this, false);
    this.savePublish = this.handleSave.bind(this, true);
    this.handleRotation = this.handleImageRotation.bind(this);
    this.avatarSaveImage = this.handleAvatarSaveImage.bind(this);
    this.editAvator = this.handleAvatarFileDrop.bind(this);
    this.editorRef = this.setEditorRef.bind(this);
    this.handleClose = this.avatarEditorModalHandler.bind(this);

    this.toast = (message) => {
      toast.info(message, {
        position: 'bottom-right',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: false,
      });
    };

    const dateOfBirth = moment(dog.date_of_birth).format('YYYY-MM-DD');

    let desexStatus = dog.fixed;
    if (desexStatus !== 'Neutered' && desexStatus !== 'Spayed' && desexStatus !== 'Entire') {
      // desex status using the deprecated checkbox value, so force field to be re-entered
      desexStatus = null;
    }

    this.state = {
      active: false,
      completed: false,
      adding: false,
      avatar_editor_modal_open: false,

      id: dog.id,
      name: dog.name,
      about: dog.about,
      breed: dog.breed ? this.props.appdata.breed.find(
        breed => breed.title === dog.breed,
      ).id : null,
      dogsize: dog.dogsize ? this.props.appdata.dogsize.find(
        dogsize => dogsize.title === dog.dogsize,
      ).id : null,
      date_of_birth: dateOfBirth,
      city: dog.city,
      good_with_children: dog.good_with_children,
      health_needs: dog.health_needs,
      hypoallergenic_coat: dog.hypoallergenic_coat,
      markers: dog.markers,
      plays_with_other_dogs: dog.plays_with_other_dogs,
      published: dog.published,
      registration: dog.registration,
      living_situation: dog.living_situation,
      availability: dog.availability,
      regularity: dog.regularity,
      photos: dog.photos,
      interests: dog.interests.map(interest => interest.id),
      needs: dog.needs.map(need => need.id),
      removed_images: [],
      avatarPhoto: [],
      avatarPhotoRotation: null,
      sex: dog.sex,
      fixed: desexStatus,

      errors: {
        name: false,
        breed: false,
        dogsize: false,
        about: false,
        registration: false,
        needs: false,
        interests: false,
        photos: false,
        publishError: false,
        health_needs: false,
        userProfilePublishError: false,
        availability: false,
        living_situation: false,
        sex: false,
      },
    };

    this.availability = availability;
    this.living_situations = livingSituations;
    this.regularity = regularity;
    this.sex = sex;
    this.fixedStatuses = fixedStatuses;
  }

  componentWillMount() {
    const dog = this.getDog();

    // You can't edit a dog that you do not own.
    if (!dog) {
      this.props.history.push('/shares');
    }
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        active: true,
      });
    }, 0);
  }

  setEditorRef(editor) {
    this.editor = editor;
  }

  getFieldsToStore() {
    const validPhotos = this.state.photos.filter(image => !image.remote);

    const fields = {
      name: this.state.name,
      about: this.state.about,
      breed: this.state.breed,
      dogsize: this.state.dogsize,
      date_of_birth: this.state.date_of_birth,
      city: this.state.city,
      good_with_children: this.state.good_with_children,
      markers: this.state.markers,
      health_needs: this.state.health_needs,
      hypoallergenic_coat: this.state.hypoallergenic_coat,
      plays_with_other_dogs: this.state.plays_with_other_dogs,
      published: this.state.published,
      registration: this.state.registration,
      availability: this.state.availability,
      living_situation: this.state.living_situation,
      regularity: this.state.regularity,
      photos: validPhotos && validPhotos.length ? validPhotos : null,
      interests: this.state.interests && this.state.interests.length ? this.state.interests : null,
      needs: this.state.needs && this.state.needs.length ? this.state.needs : null,
      removed_images: this.state.removed_images && this.state.removed_images.length ?
        this.state.removed_images : null,

      sex: this.state.sex,
      fixed: this.state.fixed,
    };

    return fields;
  }

  getDog() {
    const dogID = this.props.match.params.id;
    return this.props.user.dogs.find(pooch => pooch.id === parseInt(dogID, 10));
  }

  // Validate the form
  validateForm() {
    const errors = {};

    if (!this.state.name || !this.state.name.length) {
      errors.name = 'Please add a name';
    } else {
      errors.name = null;
    }

    if (!this.state.breed) {
      errors.breed = 'Please select a breed';
    } else {
      errors.breed = null;
    }


    if (!this.state.dogsize) {
      errors.dogsize = 'Please select the size';
    } else {
      errors.dogsize = null;
    }

    if (!this.state.date_of_birth) {
      errors.date_of_birth = 'Please enter a date of birth';
    } else {
      errors.date_of_birth = null;
    }

    if (!this.state.about || !this.state.about.length) {
      errors.about = 'Please tell us about your dog';
    } else {
      errors.about = null;
    }

    if (!this.state.registration || !this.state.registration.length) {
      errors.registration = 'Please enter a registration number';
    } else {
      errors.registration = null;
    }

    if (!this.state.regularity) {
      errors.regularity = 'Please select the most likely regularity for sharing';
    } else {
      errors.regularity = null;
    }

    if (!this.state.availability) {
      errors.availability = 'Please select the availability for sharing';
    } else {
      errors.availability = null;
    }

    if (!this.state.living_situation) {
      errors.living_situation = 'Please select the ideal living situation';
    } else {
      errors.living_situation = null;
    }

    if (!this.state.needs || !this.state.needs.length) {
      errors.needs = 'Please select at least one need';
    } else {
      errors.needs = null;
    }

    if (!this.state.sex || !this.state.sex.length) {
      errors.sex = 'Please select the sex of the dog';
    } else {
      errors.sex = null;
    }

    if (!this.state.fixed || !this.state.fixed.length) {
      errors.fixed = 'Please indicate your dog\'s desex status';
    } else {
      errors.fixed = null;
    }

    if (!this.state.health_needs || !this.state.health_needs.length) {
      errors.health_needs = 'Please add any important details about your pooch. Enter ‘nil’ if not applicable';
    } else {
      errors.health_needs = null;
    }

    if (!this.state.interests || !this.state.interests.length) {
      errors.interests = 'Please select at least one interest';
    } else {
      errors.interests = null;
    }

    if (!this.state.photos || !this.state.photos.length) {
      errors.photos = 'Please upload at least one photo';
    } else {
      errors.photos = null;
    }

    let formErrors = false;

    for (const key in errors) {   //eslint-disable-line
      if (errors[key] !== null) {
        formErrors = true;
      }
    }

    if (formErrors) {
      errors.publishError = 'Please fix any form errors to continue.';
    } else {
      errors.publishError = null;
    }

    if (formErrors) {
      this.setState({
        errors,
      });

      return false;
    }

    if (!this.props.user.published === false) {
      this.setState({
        errors: {
          userProfilePublishError: null,
        },
      });
    } else {
      this.setState({
        errors: {
          userProfilePublishError: 'Your personal profile needs to be published prior to your dog\'s profile. Save this profile now as draft.',
        },
      });

      return false;
    }

    return true;
  }

  handleSelect(name, id, value) {
    // eslint-disable-next-line
    console.log(name, id, value);
    if (value) {
      this.addKey(name, id);
    } else {
      this.removeKey(name, id);
    }

    setTimeout(() => {
      if (this.state.errors[name]) {
        // If there is an error against this field, attempt to revalidate
        this.validateForm();
      }
    }, 10);
  }

  handleMarkers(key, id, value) {
    if (value) {
      this.addMarker(key, id, value);
    } else {
      this.removeMarker(key, id);
    }
  }

  addMarker(key, id, value) {
    this.setState({
      [key]: [
        ...this.state.markers,
        {
          id,
          position: {
            lat: value.lat,
            lng: value.lng,
          },
        },
      ],
    });
  }

  removeMarker(key, id) {
    this.setState({
      [key]: this.state.markers.filter(marker => marker.id !== id),
    });
  }

  updateField(key, value) {
    this.setState({
      [key]: value,
    });

    setTimeout(() => {
      if (this.state.errors[key]) {
        // If there is an error against this field, attempt to revalidate
        this.validateForm();
      }
    }, 10);
  }

  // Add a unique key to array in state
  addKey(name, key) {
    const state = this.state;
    const inArray = state[name].find(obj => obj === key);

    // If the item is not already in the array, add it. Otherwise return state
    this.setState({
      [name]: !inArray ? state[name].concat([key]) : state,
    });
  }

  avatarEditorModalHandler() {
    this.setState({
      avatar_editor_modal_open: !this.state.avatar_editor_modal_open,
    });
  }

  // Remove key from an array in state
  removeKey(name, key) {
    const state = this.state;

    this.setState({
      [name]: state[name].filter(obj => obj !== key),
    });
  }

  handleClearImage(image) {
    const modifiedState = {
      photos: this.state.photos.filter(savedImage => savedImage.file_name !== image.file_name),
    };

    // Remember in 'removed_images' state so we can remove from remote
    if (image.remote) {
      modifiedState.removed_images = [].concat(this.state.removed_images, [image.id]);
    }

    this.setState(modifiedState);
  }

  handleFileDrop(acceptedFiles, rejectedFiles) {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const fileAsDataURL = reader.result;

        if (this.state.photos.length < 3) {
          this.setState({
            photos: [].concat(this.state.photos, [{
              id: null,
              remote: false,
              src: fileAsDataURL,
              size: file.size,
              file_name: file.name,
            }]),
          });
        }
      };
    });

    if (rejectedFiles && rejectedFiles.length) {
      this.setState({
        errors: Object.assign({}, this.state.errors, {
          photos: '1 or more images did not upload. Must be JPG or PNG, and below 2MB.',
        }),
      });
    } else {
      this.setState({
        errors: Object.assign({}, this.state.errors, {
          photos: false,
        }),
      });
    }
  }


  handleAvatarFileDrop(acceptedFiles, rejectedFiles) {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const fileAsDataURL = reader.result;

        if (!this.state.avatarPhoto.length) {
          this.setState({
            avatar_editor_modal_open: true,
            avatarPhoto: {
              id: null,
              remote: false,
              src: fileAsDataURL,
              size: file.size,
              file_name: file.name,
            },
          });
        }
      };
    });

    if (rejectedFiles && rejectedFiles.length) {
      this.setState({
        errors: Object.assign({}, this.state.errors, {
          photos: '1 or more images did not upload. Must be JPG or PNG, and below 2MB.',
        }),
      });
    } else {
      this.setState({
        errors: Object.assign({}, this.state.errors, {
          photos: false,
        }),
      });
    }
  }

  handleImageRotation() {
    const angle = (this.state.avatarPhotoRotation + 90) % 360;
    this.setState({
      avatarPhotoRotation: angle,
    });
  }

  handleAvatarSaveImage() {
    const avatarPhoto = this.state.avatarPhoto;
    const canvasImage = this.editor.props;
    if (this.state.photos.length < 3) {
      const newImage = this.editor.getImage();
      this.setState({
        avatar_editor_modal_open: false,
        photos: [].concat(this.state.photos, [{
          id: null,
          remote: false,
          src: newImage.toDataURL('image/jpeg', 0.8),
          size: avatarPhoto.size,
          file_name: avatarPhoto.name,
          rotate: canvasImage.rotate,
        }]),
      });
    }
  }

  fileSize(b) {
    let u = 0;
    const s = 1024;

    while (b >= s || -b >= s) {
      b /= s; //eslint-disable-line
      u += 1;
    }
    return (u ? b.toFixed(1) + ' ' : b) + ' KMGTPEZY'[u] + 'B';
  }

  handleSave(published) {
    if (published) {
      // If the user is trying to publish, the form must validate.
      // The user can save an incomplete form only if it's a draft
      if (!this.validateForm()) {
        return false;
      }
    }

    this.props.dispatch(updateAppState({
      loading: true,
    })).then(() => (
      this.props.dispatch(updateDogRemote(
        this.state.id,
        Object.assign({}, this.getFieldsToStore(), {
          published,
        }),
        this.props.user.access_token,
      )).then(() => {
        this.toast((published) ?
          'Your dog is now listed online' :
          'Your dog is not listed online');
        this.props.dispatch(updateAppState({
          loading: false,
        }));

        this.props.history.push('/pooch/' + this.state.id);
      }, (err) => {
        console.log(err); // eslint-disable-line no-console
        this.props.dispatch(updateAppState({
          loading: false,
        }));
      })
    ), (err) => {
      console.log(err); // eslint-disable-line no-console
      this.props.dispatch(updateAppState({
        loading: false,
      }));
    });

    return true;
  }

  render() {
    const dog = this.getDog();
    const selectedNeeds = this.state.needs;
    const selectedInterests = this.state.interests;

    if (!dog) {
      return false;
    }

    return (
      <div className={css(
        styles.container,
        this.state.active ? styles.container_active : null,
        this.state.completed ? styles.container_completed : null,
      )}>
        <ContentContainer>
          <Isvg
            cacheGetRequests
            src={POOCH_ASSET}
            className={css(styles.icon)}
          />
          <h1 className={css(styles.heading)}>
            Editing <span className={css(styles.highlight)}>{dog.name}{'\''}s</span> profile.
          </h1>
          <div className={css(styles.main)}>
            <div className={css(styles.form)}>

              <HorizontalRule pin />
              <h2 className={css(styles.sub_heading)}>Dog information</h2>
              <TextField
                id="name"
                name="name"
                label="Name"
                placeholder="Your dog's name"
                value={this.state.name}
                handler={this.setValue}
                required
                error={this.state.errors.name}
              />
              <SimpleSelect
                id="breed"
                name="breed"
                options={this.props.appdata.breed.map(breed => ({
                  value: breed.id,
                  label: breed.title,
                }))}
                value={this.state.breed}
                handler={this.setValue}
                label="Breed"
                required
                error={this.state.errors.breed}
              />
              <DateField
                id="date_of_birth"
                name="date_of_birth"
                label="Date of birth"
                type="date"
                fullWidth
                placeholder="DD/MM/YYYY"
                value={this.state.date_of_birth}
                handler={this.setValue}
                required
                error={this.state.errors.date_of_birth}
              />
              <SimpleSelect
                id="dogsize"
                name="dogsize"
                options={this.props.appdata.dogsize.map(dogsize => ({
                  value: dogsize.id,
                  label: dogsize.title,
                }))}
                value={this.state.dogsize}
                handler={this.setValue}
                label="Size"
                required
                error={this.state.errors.dogsize}
              />
              <SimpleSelect
                id="living_situation"
                name="living_situation"
                options={this.living_situations}
                label="Ideal living situation of borrower"
                value={this.state.living_situation}
                handler={this.setValue}
                error={this.state.errors.living_situation}
                required
              />
              <SimpleSelect
                id="availability"
                name="availability"
                options={this.availability}
                label="Availability"
                required
                value={this.state.availability}
                handler={this.setValue}
                error={this.state.errors.availability}
              />
              <SimpleSelect
                id="regularity"
                name="regularity"
                options={this.regularity}
                label="Regularity of sharing"
                required
                value={this.state.regularity}
                handler={this.setValue}
                error={this.state.errors.regularity}
              />
              <TextField
                id="registration"
                name="registration"
                value={this.state.registration}
                handler={this.setValue}
                label="Registration No. or Microchip No. - this will not be public."
                placeholder="Enter a valid NZ Registration number."
                required
                error={this.state.errors.registration}
              />
              <SimpleSelect
                id="sex"
                name="sex"
                options={this.sex}
                label="Sex"
                required
                value={this.state.sex}
                handler={this.setValue}
                error={this.state.errors.sex}
              />
              <SimpleSelect
                id="fixed"
                name="fixed"
                options={this.fixedStatuses}
                label="Desex Status"
                required
                value={this.state.fixed}
                handler={this.setValue}
                error={this.state.errors.fixed}
                placeholder="Please indicate your dog's desex status"
                tooltip="If you are listing a puppy, select 'entire' and
                 advise the planned date of the puppy's neuter/spay within your text"
              />
              <TextField
                id="about"
                name="about"
                label="Description"
                value={this.state.about}
                handler={this.setValue}
                textArea
                fullWidth
                showRemaining
                required
                limit={1000}
                height={85}
                placeholder="
                  Tell us a bit about your dog, its needs and availability,
                  this will show up in their profile
                "
                error={this.state.errors.about}
              />
              <div className={css(styles.checkboxes)}>
                <CheckboxField
                  id="good_with_children"
                  name="good_with_children"
                  label="My dog is good with children"
                  value={this.state.good_with_children}
                  handler={this.setValue}
                  tooltip="My dog is safe if left unsupervised around children."
                />
                <CheckboxField
                  id="plays_with_other_dogs"
                  name="plays_with_other_dogs"
                  label="My dog is keen to play with other dogs"
                  value={this.state.plays_with_other_dogs}
                  handler={this.setValue}
                  tooltip="My dog is safe if left unsupervised around other dogs."
                />
              </div>

              <HorizontalRule pin />

              <h2 className={css(styles.sub_heading)}>Dog Needs</h2>
              <p className={css(styles.paragraph)}>
                Select as many that are relevant to you.
              </p>
              <div className={css(styles.needs)}>
                {
                  this.props.appdata.need.map(need => (
                    <CheckButton
                      name="needs"
                      label={need.title}
                      id={need.id}
                      onSelect={this.selectHandler}
                      selected={
                        selectedNeeds.find(selectedNeed =>
                          need.id === selectedNeed,
                        )
                      } />
                  ))
                }
                {this.state.errors.needs ?
                  <ErrorContainer message={this.state.errors.needs} />
                  : null}
              </div>

              <HorizontalRule pin />

              <h2 className={css(styles.sub_heading)}>Doggie Interests</h2>
              <p className={css(styles.paragraph)}>
                Select as many that are relevant to you.
              </p>
              <div className={css(styles.interests)}>
                {
                  this.props.appdata.interest.map(interest => (
                    <ActivityCard
                      name="interests"
                      id={interest.id}
                      activity={interest.title}
                      label={interest.title}
                      styles={styles.interest}
                      onSelect={this.selectHandler}
                      profileHandler
                      value={
                        selectedInterests.find(selectedInterest =>
                          interest.id === selectedInterest)
                      } />
                  ))
                }
                {this.state.errors.interests ?
                  <ErrorContainer message={this.state.errors.interests} />
                  : null}
              </div>

              <HorizontalRule pin />

              <h2 className={css(styles.sub_heading)}>Important Details</h2>
              <TextField
                id="health_needs"
                name="health_needs"
                label="Health and Wellbeing Needs."
                value={this.state.health_needs}
                error={this.state.errors.health_needs}
                handler={this.setValue}
                textArea
                fullWidth
                height={85}
                placeholder="Tell us anything a borrower may need to know about looking after your
                dog. i.e. medication, dietary needs, allergies etc."
              />
              <CheckboxField
                id="hypoallergenic_coat"
                name="hypoallergenic_coat"
                value={this.state.hypoallergenic_coat}
                handler={this.setValue}
                label="My dog has a hypoallergenic coat"
              />

              {/* <HorizontalRule pin />
              <h2 className={css(styles.sub_heading)}>Your dogs favourite spots</h2>
              <p className={css(styles.paragraph)}>
                Click anywhere on the map to add a new spot or click on an existing spot
                to remove it from your favourites.
              </p>

              <div style={{
                position: 'relative',
                width: '100%',
              }}>
                <InteractiveMap
                  markers={this.state.markers}
                  handler={this.setMarkers}
                  removeHandler={this.setMarkers}
                />
              </div> */}

              <HorizontalRule pin />

              <h2 className={css(styles.sub_heading)}>Upload a profile photo</h2>
              <p className={css(styles.paragraph)}>
                You can add up to 3 images of your dog, each image has to be below 2MB and
                be .jpg or .png format.
                <br />
                For security purposes, all human faces should be removed prior to uploading.
              </p>
              {
                this.state.photos.length < 3 ? (
                  <Dropzone
                    maxSize={2097152}
                    multiple
                    accept="image/jpeg, image/png, image/bmp"
                    onDrop={this.editAvator}
                    className={css(styles.dropzone)}>
                    <Isvg
                      cacheGetRequests
                      src={UPLOAD_ASSET}
                      className={css(styles.dropzone_icon)}
                    />
                    <p>
                      Drop files to attach or
                      <span className={css(styles.dropzone_browse, styles.highlight)}> browse</span>
                    </p>
                  </Dropzone>
                ) : false
              }
              <div className={css(styles.avatarEditor)}>
                {
                  this.state.avatarPhoto.src ? (
                    <Modal
                      isOpen={this.state.avatar_editor_modal_open}
                      className={css(styles.modal_container)}
                      onRequestClose={this.handleClose}
                      style={{
                        overlay: {
                          backgroundColor: 'rgba(0,0,0,0.67)',
                          zIndex: 101,
                          display: 'flex',
                        },
                      }}
                      contentLabel="Photo Editor"
                    >
                      <div className={css(styles.modal_wrapper)}>
                        <div className={css(styles.header)}>
                          <h2 className={css(styles.modal_title)}>Photo Editor</h2>
                        </div>
                        <div className={css(styles.body)}>
                          <div className={css(styles.avatarCanvas)}>
                            <AvatarEditor
                              ref={this.editorRef}
                              image={this.state.avatarPhoto.src}
                              width={250}
                              height={250}
                              color={[255, 255, 255, 0.6]} // RGBA
                              scale={1.2}
                              rotate={this.state.avatarPhotoRotation}
                            />
                          </div>
                        </div>
                        <div className={css(styles.actions_container)}>
                          {
                            this.state.avatarPhoto.src ? (
                              <div
                                role="button"
                                tabIndex={0}
                                onClick={this.handleRotation}>
                                <img
                                  className={css(styles.rotate_icon)}
                                  src={ROTATE_ICON}
                                  alt="rotate"
                                />
                              </div>
                            ) : false
                          }
                          {
                            this.state.avatarPhoto.src ? (
                              <button
                                className={css(styles.avatarAction)}
                                onClick={this.avatarSaveImage}>
                                Save Photo
                              </button>
                            ) : false
                          }
                        </div>
                      </div>
                    </Modal>
                  ) : false
                }
              </div>
              <div className={css(styles.photos)}>
                {
                  this.state.photos && this.state.photos.length ? this.state.photos.map(image => (
                    <div className={css(styles.image_info_container)}>
                      <div className={css(styles.file_image)}>
                        <img
                          alt="Profile"
                          className={css(styles.profile_photo)}
                          src={image.src} />
                      </div>
                      <div className={css(styles.file_info)}>
                        <div className={css(styles.file_name)}>
                          {image.file_name}
                        </div>
                        <div className={css(styles.file_size)}>
                          {image.remote ?
                            image.size :
                            this.fileSize(image.size)}
                        </div>
                        <div
                          onClick={this.clearImage.bind(this, image)}
                          className={css(styles.clear_image)}
                          role="link"
                          tabIndex={0}>
                          Remove picture
                        </div>
                      </div>
                    </div>
                  )) : false
                }
                {this.state.errors.photos ?
                  <ErrorContainer message={this.state.errors.photos} />
                  : null}
              </div>
              <HorizontalRule />
              <div className={css(styles.actions)}>
                <button
                  className={css(styles.draft)}
                  onClick={this.saveDraft}>
                  Save as Draft / Unpublish
                </button>
                <button
                  className={css(styles.publish)}
                  onClick={this.savePublish}>
                  Save and publish
                </button>
              </div>
              <div className={css(styles.publishErrorWrapper)}>
                {this.state.errors.publishError ?
                  <ErrorContainer message={this.state.errors.publishError} />
                  : null}
              </div>
              <div className={css(styles.profilePublishErrorWrapper)}>
                {this.state.errors.userProfilePublishError ?
                  <ErrorContainer message={this.state.errors.userProfilePublishError} />
                  : null}
              </div>
            </div>
          </div>
        </ContentContainer>
      </div >
    );
  }
}

EditPooch.propTypes = {
  appdata: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const styles = StyleSheet.create({
  needs: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '6px -4.5px',
    [Theme.mobile_query]: {
      width: '100%',
      margin: '6px 0',
    },
  },
  interests: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 -4.5px',
  },
  interest: {
    width: 244,
    margin: '6px 4.5px',
    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  checkboxes: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    marginBottom: 30,
    [Theme.mobile_query]: {
      'flex-wrap': 'wrap',
    },
  },
  highlight: {
    color: Theme.primary,
  },
  dropzone: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 94,
    width: '100%',
    fontFamily: Theme.font_family_primary,
    backgroundColor: '#f2f2f2',
    border: '1px dashed #39b4d6',
    cursor: 'pointer',
  },
  dropzone_icon: {
    display: 'block',
    marginRight: 15,
  },
  dropzone_browse: {
    fontWeight: 900,
  },
  icon: {
    display: 'block',
    width: 159,
    margin: '0 auto 20px',
  },
  container: {
    padding: `86px 0 ${Theme.footer.height}px`,
    transition: 'transform 500ms',
    transform: 'translateX(100vw)',
  },
  container_active: {
    transform: 'translateX(0)',
  },
  container_completed: {
    transform: 'translateX(-100vw)',
  },
  main: {
    width: 750,
    maxWidth: '100%',
    margin: '0 auto',
  },
  publishErrorWrapper: {
    marginTop: 5,
    width: '100%',
  },
  profilePublishErrorWrapper: {
    marginTop: 5,
    width: '100%',
  },
  heading: {
    marginBottom: 30,
    textAlign: 'center',
    fontSize: 30,
    lineHeight: 1.17,
    fontFamily: Theme.font_family_heading,
    fontWeight: Theme.font_weight_heading,
  },
  sub_heading: {
    width: '100%',
    padding: '0 5px',
    marginBottom: 30,
    fontFamily: Theme.font_family_primary,
    fontWeight: 500,
    fontSize: 20,
    color: '#000e1f',
  },
  paragraph: {
    width: '100%',
    padding: '0 5px',
    marginTop: -15,
    marginBottom: 30,
    fontFamily: Theme.font_family_primary,
    fontSize: 14,
    color: '#828282',
    lineHeight: 1.4,
  },
  form: {
    display: 'flex',
    flexWrap: 'wrap',
    width: 750,
    maxWidth: '100%',
    margin: '0 -5px',
  },
  actions: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    [Theme.mobile_query]: {
      'flex-wrap': 'wrap',
    },
  },
  draft: {
    width: 340,
    height: 50,
    marginTop: 8,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    color: '#39b4d6',
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: Theme.white,
    cursor: 'pointer',
    outline: 'none',
    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  publish: {
    width: 340,
    height: 50,
    marginTop: 8,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    color: Theme.white,
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: '#56C5FF',
    cursor: 'pointer',
    outline: 'none',
    [Theme.mobile_query]: {
      width: '100%',
    },
  },
  photos: {
    display: 'flex',
    flexDirection: 'column',

    [Theme.mobile_query]: {
      width: '100%',
      flexDirection: 'column',
    },
  },
  profile_photo: {
    maxWidth: 150,
    maxHeight: 150,
    objectFit: 'contain',
  },
  image_info_container: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 25,
    marginBottom: 25,

    [Theme.mobile_query]: {
      width: '100%',
      flexDirection: 'column',
    },
  },
  file_image: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    [Theme.mobile_query]: {
      marginBottom: 25,
    },
  },
  file_info: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: 25,
    justifyContent: 'center',
    alignItems: 'flex-start',

    [Theme.mobile_query]: {
      width: '100%',
      paddingLeft: 0,
      marginBottom: 25,
      alignItems: 'center',
    },
  },
  file_name: {
    marginBottom: 5,

    [Theme.mobile_query]: {
      display: 'none',
    },
  },
  file_size: {
    fontWeight: 'light',
    color: Theme.dark_grey,
  },
  clear_image: {
    marginTop: 10,
    cursor: 'pointer',
    color: Theme.teal,
    fontWeight: 'bold',
  },

  avatarEditor: {
    width: '100%',
    padding: 50,
  },
  avatarCanvas: {
    display: 'flex',
    justifyContent: 'center',
    borderWidth: 2,
    borderColor: Theme.baby_blue,
    borderStyle: 'dashed',
  },
  modal_wrapper: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height: 600 - 100,
    width: '100%',
    boxSizing: 'border-box',
    padding: '0px 100px',
    [Theme.mobile_query]: {
      padding: '0px 20px 180px',
    },
  },
  close_icon: {
    position: 'absolute',
    right: 15,
    top: 15,
    outline: 'none',
    cursor: 'pointer',
    transition: 'opacity 180ms ease-in-out',
    ':hover': {
      opacity: 0.6,
    },
  },
  [Theme.desktop_query]: {
    body: {
      padding: 5,
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
    },
  },
  modal_container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    width: 590,
    maxWidth: '100vw',
    minHeight: 0,
    maxHeight: '100vh',
    backgroundColor: Theme.white,
    borderRadius: 5,
    overflow: 'hidden',
    outline: 'none',
    margin: 'auto auto',
    [Theme.mobile_query]: {
      width: 'calc(100% - 30px)',
      minHeight: '0',
      maxHeight: 'none',
      height: 'auto',
    },
  },
  actions_container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    [Theme.mobile_query]: {
      flexWrap: 'wrap',
    },
  },
  rotate_icon: {
    width: 35,
    marginTop: 10,
    marginRight: 25,
  },
  modal_title: {
    fontFamily: Theme.font_family_heading,
    fontSize: 24,
    fontWeight: '600',
    textAlign: 'center',
    padding: 25,
  },
  avatarAction: {
    width: 200,
    height: 50,
    marginTop: 8,
    fontSize: 15,
    letterSpacing: 2,
    lineHeight: '50px',
    fontFamily: Theme.font_family_secondary,
    fontWeight: Theme.font_weight_secondary,
    color: Theme.white,
    textTransform: 'uppercase',
    border: 0,
    borderRadius: 5,
    backgroundColor: '#56C5FF',
    cursor: 'pointer',
    outline: 'none',
    [Theme.mobile_query]: {
      width: '100%',
    },
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(EditPooch);



// WEBPACK FOOTER //
// ./src/views/EditPooch/index.js